import ListSkeleton from './ListSkeleton';

export default ListSkeleton;
